import Vue from 'vue'
import Router from 'vue-router'    //路由

//样式文件
import '@/common/css/base.css'       //公共样式
import '@/page/css/page.css'         //页面样式

//page页面
//标讯
import index from '@/page/index'           //首页

Vue.use(Router)

var router = new Router({
  routes: [
    {
      path: '/',
      name: '/',
      component: index
    },
    {
      path: '/index',     //首页
      name: 'index',
      component: index,
      meta: {
        title: "首页 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/tender/bigTender', //大标页
      name: 'bigTender',
      component: resolve => require(['@/page/tender/bigTender'], resolve)
      ,
      meta: {
        title: "大标 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/tender/hotTender', //推荐标讯列表页
      name: 'hotTender',
      component: resolve => require(['@/page/tender/hotTender'], resolve)
      ,
      meta: {
        title: "推荐标讯 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/tender/search', //搜索页
      name: 'search',
      component: resolve => require(['@/page/tender/search'], resolve)
      ,
      meta: {
        title: "搜索 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/tender/tenderDetail', //正文详情页
      name: 'tenderDetail',
      component: resolve => require(['@/page/tender/tenderDetail'], resolve)
      ,
      meta: {
        title: "公告正文 - U学商情",
        content: 'disable'
      }
    },{
      path: '/tender/fullScreen', //正文详情页
      name: 'fullScreen',
      component: resolve => require(['@/page/tender/fullScreen'], resolve),
      meta: {
        title: "全屏查看正文 - U学商情",
        content: 'disable'
      }
    }
    , {
      path: '/analyze', //项目分析页：搜索入口
      name: 'analyze',
      component: resolve => require(['@/page/analyze/tender'], resolve)
    }, {
      path: '/analyzeNew', //项目分析页：头部入口
      name: 'analyzeNew',
      component: resolve => require(['@/page/analyze/analyzeNew'], resolve)
      ,
      meta: {
        title: "标讯分析 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/compare', //项目分析比较页面
      name: 'compare',
      component: resolve => require(['@/page/analyze/contrast'], resolve)
    }, {
      path: '/company', //公司分析页
      name: 'company',
      component: resolve => require(['@/page/analyze/company'], resolve)
      ,
      meta: {
        title: "企业分析 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/subscription', //标讯、资质订阅
      name: 'subscription',
      component: resolve => require(['@/page/subscription/subscription'], resolve)
      ,
      meta: {
        title: "标讯、资质订阅 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/businessSubscription', //业务订阅
      name: 'businessSubscription',
      component: resolve => require(['@/page/businessSubscription/businessSubscription'], resolve)
      ,
      meta: {
        title: "业务订阅 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/conditionFilter', //数据导出--合并页面
      name: 'conditionFilter',
      component: resolve => require(['@/page/dataExport/dataExport'], resolve)
      ,
      meta: {
        title: "数据导出 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/exportOrder', //数据导出--2.导出
      name: 'exportOrder',
      component: resolve => require(['@/page/dataExport/dataExport'], resolve)
      ,
      meta: {
        title: "数据导出 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/exportSuccess', //数据导出--3.成功
      name: 'exportSuccess',
      component: resolve => require(['@/page/dataExport/dataExport'], resolve)
      ,
      meta: {
        title: "数据导出 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/analysisSearch', //分析首页-公司搜索
      name: 'analysisSearch',
      component: resolve => require(['@/page/analyze/analysisSearch'], resolve)
      ,
      meta: {
        title: "全文搜索 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/exportRecord', //导出记录页
      name: 'exportRecord',
      component: resolve => require(['@/page/exportRecord/exportRecord'], resolve)
      ,
      meta: {
        title: "导出记录 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/vipFunction', //VIP会员-VIP功能页
      name: 'vipFunction',
      component: resolve => require(['@/page/vipMember/vipFunction'], resolve)
      ,
      meta: {
        title: "VIP功能 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/vipMemberMsg', //VIP会员-成员信息页
      name: 'vipMemberMsg',
      component: resolve => require(['@/page/vipMember/vipMemberMsg'], resolve)
      ,
      meta: {
        title: "成员信息 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/vipUShare', //VIP会员-U享分
      name: 'vipUShare',
      component: resolve => require(['@/page/vipMember/vipUShare'], resolve)
      ,
      meta: {
        title: "U享分 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/myOrder', //我的订单
      name: 'myOrder',
      component: resolve => require(['@/page/order/myOrder'], resolve)
      ,
      meta: {
        title: "我的订单 - U学商情",
        content: 'disable'
      }
    }, {
      path: '/invoice', //开发票
      name: 'invoice',
      component: resolve => require(['@/page/order/invoice'], resolve)
      ,
      meta: {
        title: "开发票 - U学商情",
        content: 'disable'
      }
    },{
      path: '/attentionProject', //关注项目
      name: 'attentionProject',
      component: resolve => require(['@/page/tender/attentionProject'], resolve)
      ,
      meta: {
        title: "关注项目 - U学商情",
        content: 'disable'
      }
    },{
      path: '/attentionCompany', //关注企业
      name: 'attentionCompany',
      component: resolve => require(['@/page/tender/attentionCompany'], resolve)
      ,
      meta: {
        title: "关注企业 - U学商情",
        content: 'disable'
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next();
});



export default router



// WEBPACK FOOTER //
// ./src/router/index.js